export enum ActionTypes {
  SAVE_CHALLENGE_STEP1 = "SAVE_CHALLENGE_STEP1",
  SAVE_CHALLENGE_STEP2 = "SAVE_CHALLENGE_STEP2",
  SAVE_CHALLENGE_STEP3 = "SAVE_CHALLENGE_STEP3",
  CHALLENGE = "CHALLENGE",
  DELETE_CHALLENGE = "DELETE_CHALLENGE",
}
